import { CoinBadgeV2 } from "@components/CoinBadgeV2";
import { SelectableCoinBadge } from "@components/SelectableCoinBadge";
import { PricesModal } from "@components/modals/PricesModal";
import { useAccount } from "@contexts/AccountContext";
import { useCoins } from "@contexts/CoinsContext";
import useAlert from "@hooks/AlertHook";
import { errorPromise } from "@hooks/ApiHook";
import useModal from "@hooks/ModalHook";
import { useTxModal } from "@hooks/TxModalHook";
import { useWasmQuery } from "@hooks/WasmQueryHook";
import { useWasmX } from "@hooks/WasmXHook";
import { CollectionResponse, NftResponse } from "baaanggg";
import React, { useEffect, useState } from "react";
import { AssetRequest } from "wasmx";

export interface Props {
    nft: NftResponse,
    collection: CollectionResponse,
    onBought: () => void
}

export function NftBuyItemBox({ nft, collection, onBought }: Props) {
    const wasmx = useWasmX()
    const alert = useAlert()
    const { getCoin } = useCoins()
    const txModal = useTxModal()
    const { address } = useAccount()

    const [payment, setPayment] = useState<string>()

    const { data: sellInfo, refresh: refreshSellInfo } = useWasmQuery(wasmx => {
        if (!collection) return errorPromise()
        return wasmx.collection.query.sellInfo({
            contract: collection.collectionContract,
            data: {
                token_id: nft.tokenId
            }
        })
    }, [collection])

    const onBuy = async () => {
        try {
            if (!payment) throw new Error("Please select payment type")
            if (!wasmx || !address) throw new Error("Cannot load chain information, try to refresh the page")

            const coin = getCoin(payment)
            const asset = sellInfo!.prices.find(e => e.coin?.denom == coin?.denom || e.token?.address == coin?.cw20Address)!

            const buyMsg = wasmx.collection.execute.buy({
                contract: collection.collectionContract,
                sender: address,
                data: {
                    token_id: nft.tokenId
                }
            }, asset)

            await txModal.show(address, [buyMsg], `Buy NFT '${nft.name}'`, {
                onSuccess: async (tx) => {
                    alert.success("NFT bought successfully")
                    await refreshSellInfo()
                    onBought()
                },
                onError: (er) => alert.failed(er.message)
            })
        } catch (e) {
            if (e instanceof Error) alert.failed(e.message)
            else console.error(e)
        }
    }

    if (sellInfo) return <div
        className="rounded-2lg border border-jacarta-100 bg-white p-8 dark:border-gray-400 dark:bg-gray-900 mb-5"
    >

        <div className="flex flex-wrap">
            {
                sellInfo.prices.map(price => {
                    const coin = getCoin(price.coin?.denom ?? price.token?.address ?? "");

                    return <div className="mr-2.5 mb-2.5" key={coin?.id}>
                        <SelectableCoinBadge
                            onSelected={coinId => setPayment(coinId === payment ? undefined : coinId)}
                            isSelected={coin?.id == payment}
                            amount={Number(price.coin?.amount ?? price.token?.amount)}
                            coinId={coin?.id ?? ""} />
                    </div>
                }
                )
            }
        </div>

        <button
            onClick={onBuy}
            className="inline-block w-full rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600">
            Buy
        </button>
    </div>

    return <></>
}